/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Avatar,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string } from "yup";
import { toast } from "react-toastify";
import { useGetUserBrQuery } from "../../Store/Services/UserService";
import * as Yup from "yup";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import styles from "./AddUser.module.css";
import { useCreateUserMutation } from "../../Store/Services/UserService";

const schema = object({
  userFirstName: Yup.string().required(""),
  userLastName: Yup.string().required(""),
  userName: Yup.string().required(""),
  userEmail: Yup.string().required("").matches("^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+.[a-z]+$", "Email format is invalid!"),
  userTelephone: Yup.string().required(""),
  userMobile: Yup.string().required("([0-9][^0-9]){8,10}$"),
  userPsw: Yup.string()
    .min(
      8,
      "password should be with 1 uppercase 1 lowercase 1 number 1 special character and it should be more than 8 characters  "
    )
    .required("Password is required!")
    .max(
      12,
      "password should be with 1 uppercase 1 lowercase 1 number 1 special character and it should be more than 8 characters  "
    )
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  userConfPsw: Yup.string().oneOf(
    [Yup.ref("userPsw"), null],
    "Passwords must match"
  ),
}).required();

const AddUser = ({ handleClose }) => {
  const { data, isSuccess: brSuccess } = useGetUserBrQuery();

  const [userBr, setUserBr] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [userCreateResponse] = useCreateUserMutation();

    console.log(userBr, "userBr");
    console.log(/^\d{10}$/.test('0717224159'));

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  let brList;
  if (brSuccess) {
    brList = data?.map((br) => ({ brId: br.brId, brName: br.brName }));
  }

    console.log("user br", brList);

  const onSubmit = async (data) => {
  
    const dataSet = {
      ...data,
      userBr: userBr,
    };
    console.log(dataSet, "data set");
    if(userBr.length !== 0){
      try {
        const userUpdate = await userCreateResponse(dataSet).unwrap();
        toast.success("User successfully Created!", { position: "bottom-right" });
      } catch (err) {
        console.error("Failed to edit user details: ", err);
        toast.error(err.data?.message, { position: "bottom-right" });
      }
      handleClose();
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((currentShowState) => !currentShowState);
  };

  return (
    <div>
      <div className={styles.headingContainer}>
        <Typography fontWeight={600} variant={"h6"}>
          Add User
        </Typography>
        <IconButton className={styles.closeButton} onClick={handleClose}>
          <Close />
        </IconButton>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={styles.imageDev}>
          <Avatar
            // className={styles.avatar}
            style={{
              width: "110px",
              height: "110px",
              border: "solid 1px #9e1618",
            }}
            src={`${process.env.REACT_APP_IMAGE_URL}INVENTORY%2Favatar.png`}
          />
        </div>

        {/* Add Item form Here... */}
        <div className={styles.filed}>
          <Typography className={styles.formLabale}>First Name</Typography>
          <TextField
            {...register("userFirstName")}
            placeholder=" First Name"
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Last Name</Typography>
          <TextField
            {...register("userLastName")}
            placeholder="Last Name"
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Username</Typography>
          <TextField
            {...register("userName")}
            placeholder="Username"
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Email</Typography>
          <TextField
            {...register("userEmail")}
            placeholder="Enter Email"
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>
            Telephone Number
          </Typography>
          <TextField
            {...register("userTelephone")}
            type="number"
            placeholder="Enter Telephone Number"
            variant="outlined"
            size="small"
            pattern="[0-9]"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Mobile Number</Typography>
          <TextField
            {...register("userMobile")}
            placeholder="Enter Mobile Number"
            type="number"
            variant="outlined"
            size="small"
            className={styles.formTextFilde}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>Password</Typography>

          <TextField
            {...register("userPsw", { minLength: 8 })}
            size="small"
            fullWidth
            className={styles.formTextFilde}
            placeholder="Enter Password"
            type={showPassword ? "text" : "password"}
            error={!!errors.userPsw}
            helperText={errors.userPsw?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className={styles.filed}>
          <Typography className={styles.formLabale}>
            Confirm Password
          </Typography>

          <TextField
            {...register("userConfPsw")}
            size="small"
            fullWidth
            className={styles.formText}
            placeholder="Confrm Password:"
            type={showPassword ? "text" : "password"}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className={styles.formItem}>
          <label className={styles.formLabel}>User Br:</label>
          {userBr.length===0 && (<span className={styles.validation}> *</span>)}
          {brSuccess && (
            <Autocomplete
              className={styles.formInput}
              onChange={(_, newBr) => {
                setUserBr(newBr.map((br) => br.brId));
              }}
              size="small"
              multiple
              filterSelectedOptions
              isOptionEqualToValue={(option, value) =>
                option.brName === value.brName
              }
              options={brList}
              getOptionLabel={(option) => option.brName}
              renderInput={(params) => (
                <TextField placeholder="User Br" {...params} />
              )}
            />
          )}
        </div>
        <div className={styles.buttonRap}>
          <Button
            className={styles.submitButton}
            type="submit"
            variant="contained"
            fullWidth
            // disabled={isLoading}
          >
            Add User
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
